import { Toolbar, SaveButton, CanAccess } from 'react-admin';
import { DashboardResources } from '@src/types';

/**
 * Custom toolbar for variant SKU edit form
 * Includes save button with permission check
 */
export const VariantSkuEditToolbar = () => (
  <Toolbar>
    <CanAccess resource={DashboardResources.VariantSkus} action="edit">
      <SaveButton />
    </CanAccess>
  </Toolbar>
);
